import I18n from 'I18n';
export default {
  SEQUENCE: 'SEQUENCE',
  SEQUENCES_FOLDER: 'SEQUENCES_FOLDER',
  DOCUMENT: 'DOCUMENT',
  DOCUMENTS_FOLDER: 'DOCUMENTS_FOLDER',
  SNIPPET: 'SNIPPET',
  SNIPPETS_FOLDER: 'SNIPPETS_FOLDER',
  TEMPLATE: 'TEMPLATE',
  TEMPLATES_FOLDER: 'TEMPLATES_FOLDER',
  PLAYBOOK: 'PLAYBOOK',
  PLAYBOOKS_FOLDER: 'PLAYBOOKS_FOLDER'
};

/**
 * Exporting as a function and not an object map due to i18n initialization practices
 * https://product.hubteam.com/docs/frontend/docs/i18n/gotchas.html#i18n-used-before-ready
 */
export const getI18NLabelFromFolderType = folderContentType => {
  switch (folderContentType) {
    case 'SEQUENCES_FOLDER':
      return I18n.text(`salesContentIndexUI.header.checkbox.SEQUENCE`);
    case 'DOCUMENTS_FOLDER':
      return I18n.text(`salesContentIndexUI.header.checkbox.DOCUMENT`);
    case 'SNIPPETS_FOLDER':
      return I18n.text(`salesContentIndexUI.header.checkbox.SNIPPET`);
    case 'TEMPLATES_FOLDER':
      return I18n.text(`salesContentIndexUI.header.checkbox.TEMPLATE`);
    case 'PLAYBOOKS_FOLDER':
      return I18n.text(`salesContentIndexUI.header.checkbox.PLAYBOOK`);
    default:
      return `Unknown folder type ${folderContentType}`;
  }
};